define([
	"dojo/_base/declare",
	"csi/heading/Ref"
], function(declare,Ref) {

	return declare(Ref, {
		bBaseRenderer: true,
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			var	node = ctx.getNode();
			ctx.pushParams().setNodeURL(ctx.getParentURL());
			ctx.keyValue = node.StyleType;
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			ctx.pop();
			this.inherited(arguments);
		}
	});
});